var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeInactive = function SvgEyeInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    style: {
      marginTop: 4
    }
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eye-inactive_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#B2C9DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33,
    d: "M6.586 6.587a2 2 0 1 0 2.827 2.826m-2.26-6.026c.28-.035.564-.053.847-.054C12.666 3.333 14.666 8 14.666 8a8.77 8.77 0 0 1-1.113 1.787m-9.147-5.38A9.017 9.017 0 0 0 1.333 8s2 4.667 6.667 4.667a6.493 6.493 0 0 0 3.593-1.074M1.333 1.333l13.333 13.334"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eye-inactive_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgEyeInactive;